/* eslint-disable max-len */
import React, { FunctionComponent } from 'react';

import { Breakpoint, Card, Heading } from '@savebetter/components';

import { useBankProducts } from '../context/BankProductsContext';
import { useDatasources } from '../context/DataSourceContext';
import { replaceCustomVars } from '../utils/replaceCustomVar';

import { getLayoutTypeClasses, LayoutType } from './ProductComparison';
import { Section } from './Section';

interface NationalAverageCardProps {
  nationalAverage: string;
  nationalAverageType: string;
  nationalAverageDescription?: string;
  layoutType: LayoutType;
  viewportType: Breakpoint;
}

const NationalAverageCard: FunctionComponent<NationalAverageCardProps> = ({
  nationalAverage,
  nationalAverageType,
  nationalAverageDescription,
  layoutType,
  viewportType
}) => {
  const { contextProducts: products } = useBankProducts();
  const { contextDatasources: datasources } = useDatasources();
  const layoutTypeClasses = getLayoutTypeClasses(viewportType, layoutType);
  return (
    <Card
      horizontalPaddingClassName="none"
      shadow="shadow-none"
      rounded="rounded-md"
      className={`${layoutTypeClasses} relative box-border border-none rounded-md shadow-md sm:mt-12 md:mt-0 md:ml-4`}
    >
      <Heading
        className="w-full m-0 py-4 text-center absolute top-0 bg-black-40 rounded-t-rounded"
        kind="3"
        color="text-white"
        level="3"
        bgColor="#8E9594"
      >
        {nationalAverage}%
      </Heading>
      <Section className="pt-8">
        <div className="pt-8 px-6 text-center">
          <p>{nationalAverageType} national rate</p>
          {nationalAverageDescription && (
            <p>
              {`for ${replaceCustomVars(nationalAverageDescription, products, datasources)}`}
              <sup>1</sup>
            </p>
          )}
        </div>
      </Section>
    </Card>
  );
};

export default NationalAverageCard;
